/** Join class names, skipping empty ones. */
export function cx(...parts: (string | false | null | undefined)[]): string {
  return parts.filter(Boolean).join(' ');
}

/** Font-size utilities: Tailwind's own, arbitrary sizes, and the app's type scale tokens. */
const TEXT_SIZE = /^text-(\[\d|xs$|sm$|base$|lg$|xl$|\dxl$|meta$|sub$|body$|nav$|strong$|card$|head$|title$|tile$|greet$|figure$)/;
const WEIGHT = /^font-(thin|light|normal|medium|semibold|bold|extrabold|black)$/;

/** Which CSS property a utility sets, so an override can replace the base class. */
function group(token: string): string | null {
  const cut = token.lastIndexOf(':');
  const variant = cut >= 0 ? token.slice(0, cut + 1) : '';
  const core = token.slice(cut + 1).replace(/!$/, '');
  let key: string | null = null;
  if (/^h-/.test(core)) key = 'h';
  else if (/^w-/.test(core)) key = 'w';
  else if (/^min-w-/.test(core)) key = 'min-w';
  else if (/^px-/.test(core)) key = 'px';
  else if (/^py-/.test(core)) key = 'py';
  else if (/^p-/.test(core)) key = 'p';
  else if (/^gap-/.test(core)) key = 'gap';
  else if (/^rounded(-|$)/.test(core)) key = 'rounded';
  else if (/^whitespace-/.test(core)) key = 'ws';
  else if (/^leading-/.test(core)) key = 'leading';
  else if (TEXT_SIZE.test(core)) key = 'text-size';
  else if (/^text-/.test(core)) key = 'text-color';
  else if (WEIGHT.test(core)) key = 'weight';
  else if (/^bg-/.test(core)) key = 'bg';
  else if (/^shadow(-|$)/.test(core)) key = 'shadow';
  return key ? variant + key : null;
}

/** Base classes plus overrides, where an override drops the base class for the same property. */
export function merge(base: string, override?: string | false | null): string {
  if (!override) return base;
  const taken = new Set(override.split(/\s+/).map(group).filter((g): g is string => g !== null));
  const kept = base.split(/\s+/).filter((t) => {
    const g = group(t);
    return !g || !taken.has(g);
  });
  return `${kept.join(' ')} ${override}`.trim();
}
